"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PDFService = void 0;
var pdfjsLib = __importStar(require("pdfjs-dist"));
var HttpClient_1 = require("../../../DriveScout/API/core/HttpClient");
var PDFService = /** @class */ (function () {
    function PDFService() {
        this.pdfDoc = null;
        this.currentScale = 1.0;
        // Use local worker file to avoid CORS issues, with SITEURL environment variable
        var siteUrl = process.env.SITEURL || "";
        pdfjsLib.GlobalWorkerOptions.workerSrc = "".concat(siteUrl, "/assets/js/pdf.worker.js");
    }
    PDFService.prototype.loadPDF = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var response, _a, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, HttpClient_1.HttpClient.get(url, {
                                responseType: "arraybuffer",
                                headers: {
                                    Accept: "application/pdf",
                                },
                            })];
                    case 1:
                        response = _b.sent();
                        _a = this;
                        return [4 /*yield*/, pdfjsLib.getDocument({
                                data: response.data,
                            }).promise];
                    case 2:
                        _a.pdfDoc = _b.sent();
                        return [2 /*return*/, this.pdfDoc];
                    case 3:
                        error_1 = _b.sent();
                        console.error("Error loading PDF:", error_1);
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    PDFService.prototype.loadPDFFromFile = function (file) {
        return __awaiter(this, void 0, void 0, function () {
            var arrayBuffer, _a, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, file.arrayBuffer()];
                    case 1:
                        arrayBuffer = _b.sent();
                        _a = this;
                        return [4 /*yield*/, pdfjsLib.getDocument({ data: arrayBuffer }).promise];
                    case 2:
                        _a.pdfDoc = _b.sent();
                        return [2 /*return*/, this.pdfDoc];
                    case 3:
                        error_2 = _b.sent();
                        console.error("Error loading PDF from file:", error_2);
                        throw error_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    PDFService.prototype.getPage = function (pageNum) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.pdfDoc) {
                            throw new Error("No PDF loaded");
                        }
                        if (pageNum < 1 || pageNum > this.pdfDoc.numPages) {
                            throw new Error("Invalid page number: ".concat(pageNum));
                        }
                        return [4 /*yield*/, this.pdfDoc.getPage(pageNum)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    PDFService.prototype.getPageCount = function () {
        var _a;
        return ((_a = this.pdfDoc) === null || _a === void 0 ? void 0 : _a.numPages) || 0;
    };
    PDFService.prototype.renderPage = function (page_1, canvas_1) {
        return __awaiter(this, arguments, void 0, function (page, canvas, scale) {
            var viewport, context, renderContext, renderTask;
            if (scale === void 0) { scale = 1.0; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        viewport = page.getViewport({ scale: scale });
                        context = canvas.getContext("2d");
                        if (!context) {
                            throw new Error("Canvas context not available");
                        }
                        canvas.height = viewport.height;
                        canvas.width = viewport.width;
                        renderContext = {
                            canvasContext: context,
                            viewport: viewport,
                            canvas: canvas,
                        };
                        renderTask = page.render(renderContext);
                        return [4 /*yield*/, renderTask.promise];
                    case 1:
                        _a.sent();
                        this.currentScale = scale;
                        return [2 /*return*/];
                }
            });
        });
    };
    PDFService.prototype.getCurrentScale = function () {
        return this.currentScale;
    };
    PDFService.prototype.destroy = function () {
        if (this.pdfDoc) {
            this.pdfDoc.destroy();
            this.pdfDoc = null;
        }
    };
    return PDFService;
}());
exports.PDFService = PDFService;
